import React from 'react';
import { Icon } from 'antd';
import { decodeText } from 'util/EncodeUtils.jsx';
import moment from 'moment';
// formatters for React Bootstrap Table

const dateFormat = 'DD/MM/YYYY';

export function htmlEscape(str) {
  /* return String(str).replace(/&/g, '&amp;')
   *                   .replace(/</g, '&lt;')
   *                   .replace(/>/g, '&gt;')
   *                   .replace(/"/g, '&quot;');*/
  return str;
}

// Formattatore per icone di stato registro
// USATO IN: RegistriList.jsx
export function stateToIconFormatter(cell) {
  switch (cell) {
    case 'N':
      return (
        <span className="statusOpen" title="Aperto">
          <Icon type="edit" />
        </span>
      );
    case 'C':
      return (
        <span className="statusWait" title="Chiuso in attesa di approvazione">
          <Icon type="lock" />
        </span>
      );
    case 'A':
      return (
        <span className="statusOK" title="Approvato">
          <Icon type="like" />
        </span>
      );
    case 'Z':
      return (
        <span className="statusOK" title="Approvato e archiviato">
          <Icon type="audit" />
        </span>
      );
    default:
      return (
        <span className="statusOpen" title="Da aprire">
          <Icon type="edit" />
        </span>
      );
  }
}

// Formattatore per icone di stato registro
// USATO IN: RegistriList.jsx
export function stateToIconFormatterMedium(cell) {
  switch (cell) {
    case 'N':
      return (
        <span className="statusOpen-medium" title="Aperto">
          <Icon type="edit" />
        </span>
      );
    case 'C':
      return (
        <span className="statusWait-medium" title="Chiuso in attesa di approvazione">
          <Icon type="lock" />
        </span>
      );
    case 'A':
      return (
        <span className="statusOK-medium" title="Approvato">
          <Icon type="like" />
        </span>
      );
    case 'Z':
      return (
        <span className="statusOK-medium" title="Approvato e archiviato">
          <Icon type="audit" />
        </span>
      );
    default:
      return (
        <span className="statusOpen-medium" title="Da aprire">
          <Icon type="edit" />
        </span>
      );
  }
}

// Formattatore per tooltip con CdL su nome AF del registro
// USATO IN: RegistriList.jsx
export function insegnamentoFormatter(desc, row) {
  console.log('controllo chiusura copertura', row);
  const title = "Corso di Studio: " + row.descCDL;
  const warnTitle = "Attenzione: questa copertura è stata chiusa in data " 
                    + moment(row.dataChiusuraCopertura).format(dateFormat) + 
                    ". Si prega di rendicontare solo le attività svolte fino alla data di chiusura.";
  if (row.dataChiusuraCopertura !== null) {
    return (
      <div>
        <span title={title}>{desc}</span>
        <span title={warnTitle} class='float-right statusKO'>
          <Icon type="exclamation-circle" theme="twoTone" twoToneColor="#dc1e28" />
        </span>
      </div>
      );
  }
  return (<span title={title}>{desc}</span>);
}

// Formattatore elenco didattico di forme didattiche afferenti al registro
// USATO IN: RegistriList.jsx
export function formaDidatticaFormatter(cell) {
  return (
    <ul className="no-margin-table">
      {cell.map((listValue) => (<li key={listValue.descrizione}>{listValue.descrizione}
      ({listValue.oreDocente})</li>))}
    </ul>
  );
}

// Formattatore informazioni aggiuntive di registro
// USATO IN: RegistriList.jsx
export function infoFormatter(cell, row) {
  return (
    <span>
      <b>Cod. AF:</b> {cell}<br />
      <b>Cod. Edizione:</b> {row.codEdizione}<br />
      <b>Modulo:</b> {row.descModulo || 'Mod. Unico'}<br />
      <b>Turno:</b> {row.descTurno || 'Turno Unico'}<br />
    </span>
  );
}

// Formattatore per ore registrate e previste per registro
// USATO IN: RegistriList.jsx
export function oreSommateFormatter(cell, row) {
  return `${row.totaliRegistrate} / ${cell}`;
}

export function fixedArgumentFormatter(cell) {
  return decodeText(cell);
}

export function argumentFormatter(cell) {
  if (cell === '') {
    return (
      <span title="Campo obbligatorio" className="statusKO">
        <i className="glyphicon glyphicon-pencil"></i>
      </span>
    );
  }
  return `<span>${cell}</span><span class='float-right vcenter trasp'>
<i class='glyphicon glyphicon-pencil'></i></span>`;
}

export function editFormatter(cell) {
  if (cell === '') {
    return (
      <span title="Campo obbligatorio" className="statusKO">
        <i className="glyphicon glyphicon-pencil"></i>
      </span>
    );
  }
  return `<span>${cell}</span><span class='float-right vcenter trasp'>
<i class='glyphicon glyphicon-pencil'></i></span>`;
}

export function editFormatterNoReq(cell) {
  return `<span>${cell || ''}</span><span class='float-right vcenter trasp'>
<i class='glyphicon glyphicon-pencil'></i></span>`;
}

export function academicYearFormatter(cell) {
  return (
    <span>
      {cell - 1}/{cell}
    </span>
  );
}
